function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLivemapCameraDefaultHover = function SvgLivemapCameraDefaultHover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9680"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.836 6.709 17.064 2.8a1.761 1.761 0 0 0-1.728 0L8.564 6.709a1.718 1.718 0 0 0-.864 1.51v7.834a1.786 1.786 0 0 0 .864 1.51l6.772 3.907a1.666 1.666 0 0 0 1.728 0l6.772-3.927a1.718 1.718 0 0 0 .864-1.51V8.219a1.76 1.76 0 0 0-.864-1.51zM16.019 3.99a.3.3 0 0 1 .181-.04.586.586 0 0 1 .181.04l6.249 3.625-6.43 3.706-6.43-3.706zM9.267 16.355a.374.374 0 0 1-.181-.3V8.8l6.43 3.726v7.434zm13.865 0-6.249 3.625v-7.451l6.43-3.729v7.23a.363.363 0 0 1-.18.325z",
    "data-name": "Path 2705",
    style: {
      fill: "#4da5b5"
    },
    transform: "translate(-3.7 .21)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    "data-name": "Rectangle 4588",
    style: {
      fill: "none"
    }
  }));
};
export default SvgLivemapCameraDefaultHover;